export enum Packages {
  AVATAR_FREE_TRIAL = 'avatar-studio-free-trial',
  AVATAR_BASIC = 'avatar-studio-basic',
  AVATAR_STARTER = 'avatar-studio-starter',
  AVATAR_ADVANCED = 'avatar-studio-advanced',
  AVATAR_GROWTH = 'avatar-studio-growth',
}

export const avatarStudioPackageIds = [
  Packages.AVATAR_FREE_TRIAL,
  Packages.AVATAR_BASIC,
  Packages.AVATAR_STARTER,
  Packages.AVATAR_ADVANCED,
  Packages.AVATAR_GROWTH,
];
